import { features } from './features'; 

features.applicationType = 'agrogest';
features.hasHorizontalLogo = true;

// FITOGEST
features.hasFincas = true;
features.showMapas = true;
features.showMapaRutas = true;
features.showVentas = false;
features.showVademecumMenu = true;
features.hasProductos = true;
features.showVisitas = false;
features.showCostes = false;
features.showStock = false;
features.showTratamientosMenu = false;
features.showTareasFitosanitarias = false;
features.showTareasFertilizantes = false;
features.showTrabajadoresMaquinaria = false;
features.showMaquinaria = false;

// AGROGEST
features.showAplicadoresFichajes = true;
features.showAplicadoresPartes = true;
features.showTrabajadoresCargos = true;
features.hasClients = true;
features.showFormatHourMinute = true;
features.showTractorMarcha = true;
features.showTractorBoquillas = true;
features.showTractorRPM = true;
features.showTractorPresion = true;

// Visitas
features.activateREA = false;
features.activateSIEX = false;
features.showFichajesUbicaciones = true;

features.showClientesCrm = true;
features.showCrm = true;
features.showUsuariosLogs = true;

export const environment = {
    production: true,
    v: '2',
    serverUrl: 'https://serviobras.agrogest.com/',
    logoUrl: 'assets/logo_benibal.png',
    appName: 'serviobras',
    features: features
};
